import React, { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";

import Legend, { LegendDataItem } from "#rscz/Legend";
import { hazardTypesSelector, languageSelector } from "#selectors";

import { AppState } from "#types";

interface OwnProps {
  className?: string;
  filteredHazardTypes?: {
    title: string;
    titleNe: string | undefined;
    color: string | undefined;
  }[];
  itemClassName?: string;
}

const mapStateToProps = (state: AppState) => ({
  hazardTypes: hazardTypesSelector(state),
  language: languageSelector(state),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;
type HazardsLegendProps = OwnProps & ReduxProps;

const HazardsLegend: React.FC<HazardsLegendProps> = ({
  className,
  hazardTypes,
  language,
  filteredHazardTypes,
  itemClassName,
  ...rest
}) => {
  // Map hazard items to LegendDataItem
  const hazardItems: LegendDataItem[] = useMemo(() => {
    const items = filteredHazardTypes ?? Object.values(hazardTypes);
    return items.map((h) => ({
      key: h.title, // keySelector
      label: language.language === "en" ? h.title : (h.titleNe ?? h.title),
      color: h.color ?? "#000",
      original: h,
    })) as LegendDataItem[];
  }, [filteredHazardTypes, hazardTypes, language.language]);

  const legendKeySelector = (item: LegendDataItem) => item.key as string;
  const legendLabelSelector = (item: LegendDataItem) => item.label as string;
  const legendColorSelector = (item: LegendDataItem) => item.color as string;

  return (
    <Legend
      className={className}
      data={hazardItems}
      keySelector={legendKeySelector}
      labelSelector={legendLabelSelector}
      colorSelector={legendColorSelector}
      emptyComponent={null}
      itemClassName={itemClassName}
      {...rest}
    />
  );
};

export default connector(HazardsLegend);
